<template>
    <el-dialog
        title="整车异常发车原因"
        width="35%"
        :visible.sync="registerVisible"
        :append-to-body="true"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :before-close="beforeClose"
        :custom-class="'abnormalReasonDialog'"
        >
        <div class="reason-header">异常发车原因</div>
        <el-form ref="form" :model="form" :rules="rules">
            <el-form-item prop="msgType">
                <el-radio-group v-model="form.msgType" class="reasonType-group" @change="change">
                    <el-radio
                        v-for="item in reasonList"
                        :key="item.value"
                        :label="item.value">
                        {{ item.label }}
                        <el-input
                            v-if="item.value === '02'"
                            v-model="form.exceptionTypleMsg"
                            type="text"
                            :disabled="form.msgType !== '02'"
                            maxlength="50"
                            clearable>
                        </el-input>
                    </el-radio>
                </el-radio-group>
            </el-form-item>
        </el-form>
        <div class="remark">
            <div>注释：</div>
            <div>1、仅整车可登记</div>
            <div>2、仅“是否在始发地围栏”为“否”时可登记</div>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="handleSubmit" :loading="btnLoading">确 认</el-button>
            <el-button @click="beforeClose">取 消</el-button>
        </div>
    </el-dialog>
</template>

<script>
import { dictWithUrl } from '@/components/lots/api.js';
import { formatDictDataToLabelValue } from './util.js';
import { registerAbnormalDepartReason } from '../../../../api/dispatchOrder';
export default {
    name: 'DispatchAbnormalReason',
    props: {
        componentsData: {
            type: [Object, Array]
        },
        registerVisible: {
            type: Boolean,
            default: false
        }
    },
    data () {
        var validateRadio = (rule, value, callback) => {
            if (!value) {
                return callback(new Error('异常发车原因必选'));
            } else if (value === '02' && !this.form.exceptionTypleMsg) {
                return callback(new Error('必填备注原因,填写限制50个字。'));
            } else {
                callback();
            }
        };
        return {
            btnLoading: false,
            form: {
                msgType: '', // 异常发车原因类型
                exceptionTypleMsg: '' // 备注
            },
            rules: {
                msgType: [
                    { validator: validateRadio, trigger: ['blur', 'change'] }
                ]
            },
            reasonList: [],
            dictData: {}
        };
    },
    async mounted () {
        await this.getDicData();
        this.reasonList = formatDictDataToLabelValue(this.dictData.SYS_WHOLE_EXCEPTION_TYPE);
    },
    methods: {
        /**
         * @description 获取数据字典
         * 异常发车原因：SYS_WHOLE_EXCEPTION_TYPE
         */
        async getDicData () {
            const dict = await dictWithUrl(
                // eslint-disable-next-line max-len
                'SYS_WHOLE_EXCEPTION_TYPE'
            );
            this.dictData = dict.data;
        },
        /**
         * @description 关闭
         */
        beforeClose () {
            this.$emit('update:registerVisible', false);
            this.$emit('update');
        },
        /**
         * @description 单选框发生改变时触发事件
         */
        change () {
            // 整车异常原因不为其他时，备注输入框清空
            if (this.form.msgType !== '02') {
                this.form.exceptionTypleMsg = '';
            }
        },
        /**
         * @description 提交
         */
        handleSubmit () {
            this.$refs.form.validate(valid => {
                if (valid) {
                    this.btnLoading = true;
                    registerAbnormalDepartReason(this.getParams()).then(res => {
                        if (res && +res.code === 0) {
                            this.$message.success('保存成功');
                            this.beforeClose();
                        }
                    }).finally(() => {
                        this.btnLoading = false;
                    });
                };
            });
        },
        /**
         * @description 组装提交参数
         */
        getParams () {
            let params;
            if (Array.isArray(this.componentsData)) {
                // 是否在始发地围栏为否时，才登记
                const registerData = this.componentsData.filter(item => item.beginLandRail === '0');
                const etdoNo = registerData.map(item => item.etdoNo).join(',');
                params = {
                    etdoNos: etdoNo,
                    msgType: this.form.msgType,
                    exceptionTypleMsg: this.form.exceptionTypleMsg
                };
            } else {
                params = {
                    etdoNos: this.componentsData.etdoNo,
                    msgType: this.form.msgType,
                    exceptionTypleMsg: this.form.exceptionTypleMsg
                };
            }
            // 删除为空的字段
            // for (const key in params) {
            //     if (!params[key]) {
            //         delete params[key];
            //     }
            // }
            return params;
        }
    }
};
</script>

<style lang="less" scoped>
.abnormalReasonDialog {
    .reason-header {
        font-size: 16px;
        margin-bottom: 10px;
    }
    .el-radio {
        display: block;
        margin-bottom: 10px;
        /deep/.el-radio__input{
            .el-radio__inner {
                border-radius: 0%;
            }
        }
        /deep/ .el-radio__input {
            .el-radio__label {
                font-size: 14px;
            }
        }
    }
    .el-input {
        margin-left: 10px;
    }
    .remark {
        font-size: 13px;
        color: red;
    }
}
/deep/ .el-dialog__body {
        font-size: 16px;
        padding: 16px 50px 0px;
}
/deep/ .el-radio__label {
     font-size: 14px;
}

</style>
